import React, { Component } from "react";
import PropTypes from "prop-types";
import CampaignsForm from "./CampaignsForm";
import { createCampaign } from "../actions/index";
import { Link } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import * as Constants from '../constants';

class CampaignsNew extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    createCampaign: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  };

  onSubmit(props) {
    this.props
      .createCampaign(props)
      .then(campaign => {
        if (campaign.payload != undefined) {
          toastr.success("Workflow created!");
          this.props.history.push(`/campaigns/${campaign.payload.data.data.id}`);
        }
      });
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-5">
          <h1>Add New Workflow</h1>
          <CampaignsForm
            match={this.props.match}
            handleSubmit={this.onSubmit.bind(this)}
            mode="new"
          />
        </div>
        <div className="col-md-2 text-center m-t-10">
          <div className="vertical-line">&nbsp;</div>
          <h2 className="m-b-20">Or</h2>
          <div className="vertical-line">&nbsp;</div>
        </div>
        <div className="col-md-5">
          <h1 className="m-b-35">Pick from the Library</h1>
          <Link
            to={`/starter_campaigns?${Constants.DEFAULT_PAGINATION}`}
            className="btn btn-primary"
            style={{ width: "100%" }}
          >
            Go To The Library
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { createCampaign }
)(CampaignsNew);
